import React, { useEffect, useState } from "react";
import { client } from "@/lib/api";

export function Avatar({ photoPath, name, size = 40, testid }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let revoked = null;
    if (photoPath) {
      client.get(`/files/${photoPath}`, { responseType: "blob" })
        .then((res) => { const u = URL.createObjectURL(res.data); revoked = u; setUrl(u); })
        .catch(() => setUrl(null));
    } else setUrl(null);
    return () => { if (revoked) URL.revokeObjectURL(revoked); };
  }, [photoPath]);

  return (
    <span
      className="rounded-full inline-flex items-center justify-center shrink-0 overflow-hidden font-semibold"
      style={{ width: size, height: size, background: "var(--brand-kawaii)", color: "var(--brand-navy)", fontSize: size * 0.4 }}
      data-testid={testid}
    >
      {url ? <img src={url} alt={name} className="w-full h-full object-cover" /> : (name?.[0] || "?")}
    </span>
  );
}
